import { Schema } from "@effect/schema";
import { Brand } from "effect";

type AmountBrand = bigint & Brand.Brand<"Amount">;
const AmountBrand = Brand.nominal<AmountBrand>();

export type Amount = typeof Amount.Type;
export type AmountEncoded = typeof Amount.Encoded;

export const Amount = Schema.BigInt.pipe(
  Schema.fromBrand(AmountBrand)
).annotations({ identifier: "Amount" });

export const AmountFromBigInt = Schema.BigIntFromSelf.pipe(
  Schema.fromBrand(AmountBrand)
).annotations({ identifier: "AmountFromBigInt" });

export const AMOUNT_ZERO = makeAmount(0n);

export function makeAmount(value: bigint): Amount {
  return Amount.make(value);
}
